import { laptopMaxXL, mobileLargeMax } from '@propertypal/shared/src/constants/mediaQueries';
import platform from '@propertypal/shared/src/utils/platform';
import styled, { css } from 'styled-components';
import { Text } from '../../typography';

export const OverlayUpgradeBox = styled.div<{ $color: string }>`
  width: 100%;
  max-width: 325px;
  margin: 40px auto;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 0 4px 4px rgba(231, 229, 229, 0.9);
  border: solid 2px ${({ $color }) => $color};
  background-color: ${({ theme }) => theme.white};
  position: relative;
`;

export const UpgradeHeader = styled(Text)`
  font-family: ${platform.headingFont};
  font-size: 18px;
  font-weight: bold;
  text-align: center;
  margin-bottom: 12px;
`;

export const UpgradeText = styled(Text)`
  text-align: center;

  span {
    display: block;

    &:not(:first-child) {
      margin-top: 20px;
    }
  }
`;

export const PrimeOverlayContainer = styled.div<{ $tier?: boolean; $gold?: boolean }>`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  z-index: 2;
  padding: 0 15px;
  border-radius: 8px;

  ${({ $gold }) =>
    $gold &&
    css`
      @media (${laptopMaxXL}) {
        justify-content: flex-start;
        padding-top: max(0px, calc(50vh - 90px));
      }
    `}
`;

export const PrimeOverlayHeader = styled(Text)<{ $tier?: boolean }>`
  font-size: 18px;
  font-weight: bold;
  text-align: center;
  max-width: ${({ $tier }) => ($tier ? '350px' : 'none')};
  margin: 0 auto 18px auto;
  color: ${({ theme }) => theme.textDark};

  ${({ $tier }) =>
    $tier &&
    css`
      span {
        display: block;
      }
    `}

  b {
    text-transform: capitalize;
  }

  @media (${laptopMaxXL}) {
    font-size: 22px;
  }

  @media (${mobileLargeMax}) {
    font-size: 18px;
  }
`;

export const PrimeOverlayExpire = styled(Text)<{ $tier?: boolean }>`
  text-align: center;
  max-width: ${({ $tier }) => ($tier ? '250px' : 'none')};
  margin: 0 auto;
  color: ${({ theme }) => theme.textDark};

  ${({ $tier }) =>
    $tier &&
    css`
      span {
        display: block;
      }
    `}
`;
